import { createEmbeddingContext } from "amazon-quicksight-embedding-sdk";
import { useRef, useEffect, useState } from "react";
import "./EmbeddedChart.css";
import errGif from "../images/error.gif";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import Cards from "./Cards";

const EmbeddedChart = () => {
  const dashboardRef = useRef([]);
  const [dashboardId, setDashboardId] = useState(
    "556c7045-49de-4b71-96f4-88849d2a8941"
  );
  const [embeddedDashboard, setEmbeddedDashboard] = useState(null);
  const [dashboardUrl, setDashboardUrl] = useState(null);
  const [embeddingContext, setEmbeddingContext] = useState(null);
  const [err, seterr] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      fetch(
        "https://ud4rzqn0l7.execute-api.us-east-1.amazonaws.com/embed/anonymous-embed"
      )
        .then((response) => response.json())
        .then((response) => {
          setDashboardUrl(response.EmbedUrl);
          // apiSuccess = true;
        })
        .catch((error) => {
          console.log(error);
          // apiSuccess = false;
          seterr(true);
        });
    }, 1);
    return () => clearTimeout(timeout);
  }, []);

  const createContext = async () => {
    const context = await createEmbeddingContext();
    setEmbeddingContext(context);
  };

  useEffect(() => {
    if (dashboardUrl) {
      createContext();
    }
  }, [dashboardUrl]);

  useEffect(() => {
    if (embeddingContext) {
      embed();
    }
  }, [embeddingContext]);

  const embed = async () => {
    const options = {
      url: dashboardUrl,
      container: dashboardRef.current,
      height: "250px",
      width: "380px",
      borderRadius: "10px",
      padding: 0,
    };

    const newEmbeddedDashboard = await embeddingContext.embedDashboard(options);
    setEmbeddedDashboard(newEmbeddedDashboard);
  };

  useEffect(() => {
    if (embeddedDashboard) {
      embeddedDashboard.navigateToDashboard(dashboardId, {});
    }
  }, [dashboardId]);

  const changeDashboard = async (e) => {
    const dashboardId = e.target.value;
    setDashboardId(dashboardId);
  };

  if (!err) {
    return (
      <main ref={dashboardRef}>
        {/* <select id="dashboard" value={dashboardId} onChange={changeDashboard}>
          <option value="556c7045-49de-4b71-96f4-88849d2a8941">
            Spending Trend
          </option>
        </select> */}
        <div />
      </main>
    );
  } else {
    return (
      <Cards
        title="Error"
        Icon={ErrorOutlineOutlinedIcon}
        subheading="Couldn't establish connection with AWS Quicksight"
        sidesubheading=""
        isWhite="true"
      />
    );
  }
};

export default EmbeddedChart;
